export default function getToken() {
  return localStorage && localStorage.getItem ? `Bearer ${localStorage.getItem("token")}` || "" : ""
}
